import React from 'react';
export function CostComparison() {
  const costs = [{
    situation: 'Facturas sin control del acumulado',
    cost: 'Exclusión de oficio sin aviso'
  }, {
    situation: 'Pesos quietos en el banco',
    cost: 'Pérdida del 4-5% mensual por inflación'
  }, {
    situation: 'Percepciones no reclamadas',
    cost: '$40.000-$120.000 regalados al fisco por año'
  }, {
    situation: 'Sin protocolo ante notificaciones',
    cost: 'Respondés mal y agravás la situación'
  }];
  return <section className="py-16 px-4 sm:px-6 lg:px-8" data-id="element-22">
      <div className="max-w-4xl mx-auto" data-id="element-23">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12 text-[#1A1A1A]" data-id="element-24">
          ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="overflow-x-auto mb-8 bg-white rounded-lg shadow-sm border border-[#EAE5DC]" data-id="element-25">
          <table className="w-full border-collapse" data-id="element-26">
            <thead data-id="element-27">
              <tr className="border-b-2 border-[#EAE5DC]" data-id="element-28">
                <th className="text-left p-4 font-bold text-[#1A1A1A] bg-[#FAF7F2]" data-id="element-29">
                  Sin Kit Tools Universo
                </th>
                <th className="text-left p-4 font-bold text-[#E85D5D] bg-[#E85D5D]/10" data-id="element-30">
                  Costo Real
                </th>
              </tr>
            </thead>
            <tbody data-id="element-31">
              {costs.map((row, index) => <tr key={index} className="border-b border-[#EAE5DC] hover:bg-[#FAF7F2] transition-colors" data-id="element-32">
                  <td className="p-4 text-[#1A1A1A] font-medium" data-id="element-33">
                    {row.situation}
                  </td>
                  <td className="p-4 text-[#E85D5D] font-semibold bg-[#E85D5D]/5" data-id="element-34">
                    {row.cost}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <p className="text-lg text-[#6B7280] text-center leading-relaxed" data-id="element-35">
          La próxima notificación de AFIP puede llegar esta semana. El que tiene
          un sistema, la resuelve en 48 horas. El que no lo tiene, la pasa mal.
        </p>
      </div>
    </section>;
}